<template>
  <section class="container incellderm_products">
    <h1 class="tit mb-60"><strong>Lifening</strong> Products</h1>
    <!-- <scroll-products-section :product-list="productList"/> -->
    <div class="product">
      <ul class="row">
        <li v-for="(item, index) in productList" :key="index" @click.prevent="moveToProductPage(item.productsId)" class="col-md-3 cursor" :class="{'offset-md-3': index === 0}">
          <div class="img-wrap">
            <img :src="item.productsMainImageUrl" :alt="item.mainPageKoreanName">
          </div>
          <p class="txt-set--desc">{{item.mainPageContents}}</p>
          <h2 class="txt-set--tit">{{item.mainPageKoreanName}}</h2>
        </li>
      </ul>
    </div>
    <a href="" class="btn-st03 btn-plus" @click.prevent="goList"><div class="btnin">더보기</div></a>
    <!-- <list-products-section :new-product-list="productList"/> -->
  </section>
</template>

<script>
// import ListProductsSection from './ListProductsSection.vue';
// import ScrollProductsSection from './ScrollProductsSection.vue';
// import productApi from '@/apis/product';

export default {
  name: 'ProductsSection',
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    // ScrollProductsSection,
    // ListProductsSection,
  },
  methods: {
    moveToProductPage(productsId) {
      this.$router.push(`/products/${productsId}`);
    },
    goList() {
      this.$router.push('/products');
    },
  },
};
</script>

<style lang="scss" scoped>
.product{
  text-align: center;
  img{
    width: 100%;
  }
}
.btn-st03.btn-plus{
  margin-top: 5rem;
}
.img-wrap{
  overflow: hidden;
  position: relative;
  padding-bottom: 100%;
  img{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.cursor{
  cursor: pointer;
}
</style>
